import { render } from "./AddServiceMenu.vue?vue&type=template&id=5333b153&scoped=true"
import script from "./AddServiceMenu.vue?vue&type=script&lang=js"
export * from "./AddServiceMenu.vue?vue&type=script&lang=js"

import "./AddServiceMenu.vue?vue&type=style&index=0&id=5333b153&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5333b153"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QBanner});
